const KEY_ACCESS_TOKEN = 'access_token';
const KEY_REFRESH_TOKEN = 'refresh_token';
const KEY_ROLE = 'role';
const KEY_FUNCTION = 'funtion';
const KEYS = {
  KEY_ACCESS_TOKEN,
  KEY_REFRESH_TOKEN,
  KEY_ROLE,
  KEY_FUNCTION,
};

/**
 * Ecrit l'access token en local storage
 * @param token
 */
const setAccessToken = async (localStoragePrefix:string,token?:string) => {
  if (token !== undefined && token !== null && token.trim() !== '') {
    window.localStorage.setItem(localStoragePrefix + KEYS.KEY_ACCESS_TOKEN, token);
  }
  else {
    window.localStorage.removeItem(localStoragePrefix + KEYS.KEY_ACCESS_TOKEN);
  }
};

/**
   * Ecrit le refresh token en local storage
   * @param token
   */
const setRefreshToken = (localStoragePrefix:string,token?:string) => {
  if (token !== undefined && token !== null && token.trim() !== '') {
    window.localStorage.setItem(localStoragePrefix + KEYS.KEY_REFRESH_TOKEN, token);
  }
  else {
    window.localStorage.removeItem(localStoragePrefix + KEYS.KEY_REFRESH_TOKEN);
  }
};

/**
 * Ecrit le role en local storage
 * @param role
 */
const setRole = (localStoragePrefix:string,role?:string) => {
  if (role !== undefined && role !== null && role.trim() !== '') {
    window.localStorage.setItem(localStoragePrefix + KEYS.KEY_ROLE, role);
  }
  else {
    window.localStorage.removeItem(localStoragePrefix + KEYS.KEY_ROLE);
  }
};

/**
 * Ecrit la function en local storage
 * @param function
 */
const setFunction = (localStoragePrefix:string,fonction?:string) => {
  if (fonction !== undefined && fonction !== null && fonction.trim() !== '') {
    window.localStorage.setItem(localStoragePrefix + KEYS.KEY_FUNCTION, fonction);
  }
  else {
    window.localStorage.removeItem(localStoragePrefix + KEYS.KEY_FUNCTION);
  }
};

export {setAccessToken,setRefreshToken,setRole,setFunction,KEYS};
